export default "__VITE_ASSET__m7jReIHl__"